import { ServerWithSummarize } from '../Models/server-with-summarize'
import * as gZip from 'gzip-js'
import { UserInfo } from '../Models/user-info'
let
    requestSummarize = {serverList: [], userInfo: new UserInfo(null, null, null)};

const generateURL = (queryParameterVal) => {
    const
        domain = window.location,
        queryParameterKey = 'shareKey',
        queryParameterValue = queryParameterVal,
        url = `${domain}?${queryParameterKey}=${queryParameterValue}`;

    return url;
}



export const addToSummarize = (hostName, pingIndex, averageDownloadSpeed, maxDownloadSpeed) => {
    const serverToPush = new ServerWithSummarize(hostName, pingIndex, averageDownloadSpeed, maxDownloadSpeed);

    requestSummarize.serverList.push(serverToPush);
}

export const encodeSummarize = () => {
    const
        jsonSummarize =JSON.stringify(requestSummarize),
        gzipSummarize = gZip.zip(jsonSummarize,{level: 9}),
        base64Summarize = btoa(String.fromCharCode.apply(null, new Uint8Array(gzipSummarize)));
;
    return generateURL(base64Summarize);
}

export const decodeSummarize = (queryString)  => {
     const
        base64Decode = atob(queryString),
        stringToArrayDecode = [...base64Decode].map(char => char.charCodeAt(0)),
        gZipDecode = gZip.unzip(stringToArrayDecode),
        jSonDecode = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(gZipDecode))),
        objectToPush = {serverList: jSonDecode.serverList.map((el) => new ServerWithSummarize(el.hostName, el.pingIndex, el.averageDownloadSpeed, el.maxDownloadSpeed)), userInfo: new UserInfo(jSonDecode.userInfo.userIp, jSonDecode.userInfo.userHost, jSonDecode.userInfo.userCountry)}

    return objectToPush;
}

export const addUserInfoToSummarize = (userInfoClassObject) => {
    requestSummarize.userInfo = userInfoClassObject;
}
